import ProfileInformationsService from "@services/profile-informations-service";
import { getAllInstancesByName, getSingleInstanceByName } from "../../../core";
import Component from "../../component.abstract";
import { notifyFromAlert } from "../../helpers/notifs";
import ProfileCv from "../cv/profile-cv";
import NavElement from "../navigation/nav-element";
import NavList from "../navigation/nav-list";
import ProfilePersonal from "../personal/profile-personal";
import ProfileSearch from "../search/profile-search";
import ProfileSituation from "../situation/profile-situation";

interface Error {
    Message: string
}

interface ProfileInformationsProps {
    url: string;
    messageFirstLogin: string;
}

export default class ProfileInformations extends Component {
    private url: string;
    private data: any;
    private searchFields: NodeListOf<HTMLInputElement>;
    public visibleInput: HTMLInputElement;
    private navList:NavList;
    private navElement: Array<NavElement> = [];
    private cvForm: ProfileCv; 
    private openedTooltip = false;
   

    constructor(private props: ProfileInformationsProps, element: HTMLElement) {
         super(props, element);
         this.url = this.props.url;
    }
    mounted(): void {
        this.searchFields = this.element.querySelectorAll(".search-field");
        this.visibleInput = this.element.querySelector("input#visible");

        this.navList = getSingleInstanceByName("NavList");
        this.setCompletion();

        this.cvForm = getSingleInstanceByName("ProfileCv");
        PubSub.subscribe("profilecv.toggled", (msg: string, value:boolean) => {
            this.visibleInput.checked = value;
            this.handleToggle();
        })

        PubSub.subscribe("nav-element-loaded", () => {
            const navElementInstances: Array<NavElement> = getAllInstancesByName("NavElement");
            for(const instance of navElementInstances) {
                this.navElement.push(instance);
            }
        })

        if(this.url) {
            this.call();
        }

    }
    call():void {
        const service = new ProfileInformationsService(this.url);
        
        service.setErrorHandler((error:Error) => {
            this.displayError(error);
        });

        service.get((response:any) => {
            try {

                PubSub.publish("render-grid-side");

                this.data = response;
                this.displayResults();
                this.addHandlers();
                this.initSearchLabels();
                this.setCompletion();
                //Send event GA on load, only if there is no anchor # in url
                if (location.href.indexOf("#") === -1) {
                    if (this.data.trackingsLoad && this.data.trackingsLoad.length){
                        this.data.trackingsLoad[0].event = "VirtualPageview"
                        window.dataLayer.push(
                            this.data.trackingsLoad[0]
                        );  
                    }  
                }
            } catch(e) {
                this.displayError();
            }
        });
    }
    setUrl(newurl:string):void {
        this.url = newurl;
    }
    getUrl():string {
        return this.url;
    }
    setCompletion():void {
       if (this.navList && this.data) {
            this.navList.oneClickTips.classList.toggle('visible', this.data.isDisplayLayoutCompleteField);

            this.navList.setCompletion({
                "isCompleteCurrentSearch": this.data.isCompleteCurrentSearch,
                "isCompleteCurrentSituation": this.data.isCompleteCurrentSituation,
                "isCompleteResumes": this.data.isCompleteResumes,
                "isCompletePersonalInfos": this.data.isCompletePersonalInfos,
            });
        }
    }
    displayProgression(): void {
        this.element.querySelector<HTMLElement>("[data-id=progression]").innerText = this.data.completionPercentage;
        
        const step10 = Math.floor(this.data.completionPercentage / 10) * 10,
            pie = this.element.querySelector(".header .pie-wrapper");
        pie.classList.remove("progress-0", "progress-10", "progress-20", "progress-30", "progress-40", 
            "progress-50", "progress-60", "progress-70", "progress-80", "progress-90", "progress-100");
        pie.classList.add("progress-" + step10);
    }
    handleToggle():void {
        this.visibleInput.disabled = true;
        const service = new ProfileInformationsService(this.url);
        const data = {
            "isVisibleToRecruiters": this.visibleInput.checked
        };

        service.setErrorHandler((error:Error) => {
            this.displayError(error)
             this.visibleInput.disabled = false;
        });

        service.put(data, (response:any) => {
            this.data = response.infosProfil;
            this.displayResults();
             // Add tracking event on switch cv visibility
            const trackingsClick = this.data.trackingsClick[0]
            const action = this.data.isVisibleToRecruiters ? "Activer" : "Désactiver";
            const myResume = document.querySelector("[data-profile-cv]")
            if (myResume === null || (myResume && myResume.classList.contains("hidden"))) {
                trackingsClick.EventLibelle = "[EC-Profil-Home] - CV - " + action
            } else {
                trackingsClick.EventLibelle = "[EC-Profil-MesCv] - " + action
            }
            window.dataLayer.push(trackingsClick)
            this.visibleInput.disabled = false;
        })
    }
    displayResults():void {
        if (this.data.firstname) {
            this.element.querySelector<HTMLElement>("[data-id=firstname]").innerText = 
                this.data.firstname.length <= 20 ? this.data.firstname : "";
        }

        if (Number.isInteger(this.data.completionPercentage)) {
            this.displayProgression();
        }

        if (this.data.isVisibleToRecruiters) {
            this.visibleInput.checked = true;
        } else {
            this.visibleInput.checked = false;
        }

        if(this.data.isReadyCvTk) {
            this.visibleInput.removeAttribute("disabled");
        } else {
            this.visibleInput.setAttribute("disabled", "");
        }

        if (Number.isInteger(this.data.nbCvView)) {
            this.element.querySelector<HTMLElement>("[data-id=cv-seen-number]").innerText = this.data.nbCvView;

            const numberLabel = this.element.querySelector<HTMLElement>("[data-id=cv-seen-number] + div");
            if (this.data.nbCvView < 2) {
                numberLabel.innerText = "recruteur";
            } else {
                numberLabel.innerText = "recruteurs";
            }
        }

        this.element.querySelector<HTMLElement>("[data-id=last-update]").innerText = this.data.lastUpdateLabel;

        const jobSpan = this.element.querySelector<HTMLElement>("[data-id=cv-job] span");
        if (this.data.currentJob) {
            jobSpan.innerText = this.data.currentJob;
            jobSpan.classList.remove("unset");
            jobSpan.classList.add("set");
        } else {
            jobSpan.innerText = "Non renseigné";
            jobSpan.classList.remove("set");
            jobSpan.classList.add("unset")
        }

        const homeSpan = this.element.querySelector<HTMLElement>("[data-id=cv-home] span");
        if (this.data.residenceLocation) {
            homeSpan.innerText = this.data.residenceLocation;
            homeSpan.classList.remove("unset");
            homeSpan.classList.add("set");
        } else {
            homeSpan.innerText = "Non renseigné";
            homeSpan.classList.remove("set");
            homeSpan.classList.add("unset")
        }

        const statusSpan = this.element.querySelector<HTMLElement>("[data-id=cv-status] span");
        if (this.data.currentSituation) {
            statusSpan.innerText = this.data.currentSituation;
            statusSpan.classList.remove("unset");
            statusSpan.classList.add("set");
        } else {
            statusSpan.innerText = "Non renseigné";
            statusSpan.classList.remove("set");
            statusSpan.classList.add("unset")
        }

        if (this.data.isCompletePersonalizedOffers === true) {
            this.searchFields[0].classList.remove("incomplete");
            this.searchFields[0].classList.add("complete");
        } else {
            this.searchFields[0].classList.remove("complete");
            this.searchFields[0].classList.add("incomplete");
        }

        if (this.data.isCompleteVisibleToRecruiter === true) {
            this.searchFields[1].classList.remove("incomplete");
            this.searchFields[1].classList.add("complete");
        } else {
            this.searchFields[1].classList.remove("complete");
            this.searchFields[1].classList.add("incomplete");
        }

        if (this.data.isCompleteRecruiterOpportunities === true) {
            this.searchFields[2].classList.remove("incomplete");
            this.searchFields[2].classList.add("complete");
        } else {
            this.searchFields[2].classList.remove("complete");
            this.searchFields[2].classList.add("incomplete");
        }

        if (this.data.isCompleteApplyOneClick === true) {
            this.searchFields[3].classList.remove("incomplete");
            this.searchFields[3].classList.add("complete");
        } else {
            this.searchFields[3].classList.remove("complete");
            this.searchFields[3].classList.add("incomplete");
        }
    }
    displayError(error?:Error):void {
        let  message = "Aïe, une erreur est survenue, rechargez la page et réessayez."
        if (error && error.Message) {
            message = error.Message;
        }

        notifyFromAlert({
            "Icon": 2,
            "Message": message,
            "AnalyticsTrackings": "",
            "sticky": true
        }, true);
    }
    addHandlers():void {
        const fields = this.element.querySelectorAll(".global-cv-fields-editable [data-anchor]");
        fields.forEach((field) => {
            field.addEventListener("click", (event) => {
                const anchor = (<HTMLElement>event.currentTarget).getAttribute("data-anchor");
                for(let i = 0; i < this.navElement.length; i++) {
                    if(this.navElement[i].props.anchor === anchor) {
                        this.navElement[i].getElement().click();
                        break;
                    }
                }
            });
        });

        this.visibleInput.addEventListener("change", () => {
  
            PubSub.publish("profileinformation.toggled", this.visibleInput.checked)
            this.handleToggle();
        });
    }
    initSearchLabels():void {
       for (let i = 0; i < this.searchFields.length; i++) {
            this.searchFields[i].querySelector('input[type="checkbox"]').addEventListener("change", (event) => {
                if ((<HTMLInputElement>event.target).checked) {
                    this.openedTooltip = true;

                    // When a tooltip is opened, close the others
                    for (let j = 0; j < this.searchFields.length; j++) {
                        const input = this.searchFields[j].querySelector<HTMLInputElement>('input[type="checkbox"]');
                        if (input.id !== (<HTMLElement>event.target).id && input.checked) {
                            input.checked = false;
                        }
                    }

                    // Also, highlight the related sections
                    this.highlight(true, (<HTMLElement>event.target).id);
                } else {
                    this.openedTooltip = false;
                    this.highlight(false);
                }
            });

            // Highlight related sections on mouse over if no tooltip opened
            this.searchFields[i].addEventListener("mouseover", (event) => {
                if (!this.openedTooltip) {
                    this.highlight(true, (<HTMLElement>event.currentTarget).getAttribute("data-id"));
                }
            });

            this.searchFields[i].addEventListener("mouseleave", () => {
                if (!this.openedTooltip) {
                    this.highlight(false);
                }
            });
        }   
    }
    highlight(activate: boolean, id?: string):void {
        if (activate) {
            this.navList.highlight(true, id);
        } else {
            this.navList.highlight(false);
        }
    }
    setData(data:any) {
        this.data = data;
    }
    getData():any {
        return this.data;
    }
}
